<app-message [service]="messageService"></app-message>

<div id="qr-code-scanner-video"
  class="position-fixed z-50 top-0 start-0 end-0 bottom-0 d-flex flex-column align-items-center justify-content-center pe-none rounded overflow-hidden"
  style="z-index: 10000; background-color: rgba(0 0 0 / .9); transition: opacity 1s;"
  [style]="action.isStart ? 'opacity: 1;' : 'opacity: 0'" [class]="action.isStart ? 'pe-auto' : ''"
  (click)="action.stop()">
  <ngx-scanner-qrcode #action="scanner" [isBeep]="false" style="width: 100%; height: auto;"
    [constraints]="{ video: { width: 1280, height: 720, facingMode: 'environment' } }"></ngx-scanner-qrcode>

</div>

<form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)" id="charging-station-details-form"
  *ngIf="entity && formService.formCreated">
  <div class="container-fluid mb-3">
    <div class="row">
      <div class="col-12 col-xl-8 mb-2 p-0">
        <div style="height:291px;" leaflet id="map" [leafletOptions]="options" (leafletMapReady)="onMapReady($event)"
          class="me-lg-2 border-1 rounded-2 shadow-sm">
        </div>
      </div>
      <div class="col-12 col-xl-4">
        <div class="row border border-1 rounded-2 pb-3 shadow-sm">
          <div class="col-12 pt-2">
            <h5>Adresse</h5>
          </div>
          <div class="col-9 col-md-8 p-2 m-0">
            <label class="form-label" i18n="@@StreetLabel">Straße</label>
            <input type="text" id="street" [readonly]="this.isUser" formControlName="street" class="form-control" />
            <div class="error">
              <em *ngIf="formService.validateControl('street') && formService.hasError('street', 'required')"
                i18n="@@StreetRequiredError">Straße wird benötigt</em>
            </div>
          </div>
          <div class="col-3 col-md-4 p-2 m-0">
            <label class="form-label" i18n="@@HouseNumberLabel">Nr.</label>
            <input type="text" id="houseNumber" [readonly]="this.isUser" formControlName="houseNumber"
              class="form-control" />
            <div class="error">
              <em *ngIf="formService.validateControl('houseNumber') && formService.hasError('houseNumber', 'required')"
                i18n="@@StreetRequiredError">Hausnummer wird benötigt</em>
            </div>
          </div>
          <div class="col-4 col-md-4 p-2 m-0">
            <label class="form-label" i18n="@@PostalCodeLabel">Postleitzahl</label>
            <input type="text" id="postalCode" [readonly]="this.isUser" formControlName="postalCode"
              class="form-control" maxlength="6" />
            <div class="error">
              <em *ngIf="formService.validateControl('postalCode') && formService.hasError('postalCode', 'required')"
                i18n="@@StreetRequiredError">Postleitzahl wird benötigt</em>
              <em *ngIf="formService.validateControl('postalCode') && formService.hasError('postalCode', 'pattern')"
                i18n="@@IncorrectInputError">Falsche Eingabe</em>
              <em *ngIf="formService.validateControl('postalCode') && formService.hasError('postalCode', 'maxlength')"
                i18n="@@ExceededMaxLengthPLZError">Postleitzahl zu lang</em>
              <em *ngIf="formService.validateControl('postalCode') && formService.hasError('postalCode', 'minlength')"
                i18n="@@MissingNumbersPLZError">Postleitzahl zu kurz</em>
            </div>
          </div>
          <div class="col-8 col-md-8 p-2 m-0">
            <label class="form-label" i18n="@@PCityLabel">Ort</label>
            <div class="input-group">
              <input type="text" id="city" [readonly]="this.isUser" formControlName="city" class="form-control" />
              <a class="btn btn-yellow" (click)="CalculateGPS();" id="calculate_coordinate"
                ngbTooltip="Längen- und Breitengrad aus der Adresse berechnen" i18n-ngbTooltip="@@CalculateGPSTooltip">
                <app-svg source="icons/feather/map-pin" height="18"></app-svg>

              </a>
            </div>
            <div class="error">
              <em *ngIf="formService.validateControl('city') && formService.hasError('city', 'required')"
                i18n="@@StreetRequiredError">Ort wird benötigt</em>
            </div>
          </div>
          <div class="col-12 p-2 m-0">
            <label class="form-label" i18n="@@CountryLabel">Land</label>
            <input type="text" id="country" [readonly]="this.isUser" formControlName="country" class="form-control" />
          </div>
          <div class="col-6 p-2 m-0">
            <label class="form-label" i18n="@@GPSLabelLat">GPS Latitude</label>
            <input type="text" id="lat" [readonly]="this.isUser" formControlName="lat" class="form-control" />
          </div>
          <div class="col-6 p-2 m-0">
            <label class="form-label" i18n="@@GPSLabelLon">GPS Longitude</label>
            <div class="input-group">
              <input type="text" id="lon" [readonly]="this.isUser" formControlName="lon" class="form-control" />
              <a class="btn btn-yellow" (click)="openLatLonLink();" id="open_map"
                ngbTooltip="Längen-/und Breitengrad in GoogleMaps anzeigen" i18n-ngbTooltip="@@GPSDetailsTooltip">
                <app-svg source="icons/feather/external-link" height="18"></app-svg>
              </a>
            </div>
          </div>
          <div class="error">
            <em
              *ngIf="formService.validateControl('lat') && formService.hasError('lat', 'required') || formService.validateControl('lon') && formService.hasError('lon', 'required')"
              i18n="@@StreetRequiredError">GPS-Koordinaten werden benötigt</em>
          </div>
        </div>
      </div>
    </div>
  </div>


  <ul ngbNav #snav="ngbNav" [(activeId)]="activeTab" class="nav-tabs nav-tabs-classic">
    <li [ngbNavItem]="1" domId="general_setup">
      <a ngbNavLink i18n="@@DetailsLink">Allgemein</a>

      <ng-template ngbNavContent>

        <div class="d-colspan">
          <label for="name">Name*</label>
          <input type="text" id="name" [readonly]="this.isUser" formControlName="name" class="form-control" />
        </div>
        <div class="d-grid">
          <label for="customer" i18n="@@OwnerLabel" *ngIf="this.isOperator">Besitzer</label>
          <select class="form-select" id="customer" formControlName="customer" aria-label="CustomersSelect"
            *ngIf="this.isOperator && switchCustomer" (change)="updateAddress();">
            <option *ngFor="let customer of customers" value="{{ customer.id }}">{{ customer.company}} {{
              customer.fullName }} ({{ customer.email}})</option>
          </select>
          <div class="input-group" *ngIf="this.isOperator && !switchCustomer">
            <input id="customerName" formControlName="customerName" class="form-control" readonly />
            <a class="btn btn-yellow" id="open_map" (click)="switchUser()"
              ngbTooltip="Klicken um dieser Ladestation einen neuen Besitzer zuzuweisen."
              i18n-ngbTooltip="@@GPSDetailsTooltip">
              <app-svg source="icons/feather/repeat" height="18" class="m-0 p-0"></app-svg>
            </a>
          </div>

          <label for="chargingGroup" i18n="@@GroupLabel" *ngIf="entity.chargingstationGroupsDto != null">Gruppen</label>
          <ng-select id="chargingGroup" *ngIf="entity.chargingstationGroupsDto != null" class="ng-select disable-arrow"
            formControlName="chargingstationGroups" aria-placeholder="Keine Einträge vorhanden."
            i18n-aria-placeholer="@@NoEnrtyPlaceHolderText" [searchable]="false" [clearable]="false" [multiple]="true"
            bindLabel="name">
          </ng-select>

        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="6" domId="chargingpoints">
      <a ngbNavLink i18n="@@ChargePointsInfo">Ladepunkte</a>

      <ng-template ngbNavContent>
        <ul ngbNav #cnav="ngbNav" [(activeId)]="c1" class="nav-tabs nav-tabs-classic" formArrayName="chargingPoints"
          style="border-left: 0px;">
          <li *ngFor="let point of formService.form.get('chargingPoints').controls; let i = index" [formGroupName]="i"
            [ngbNavItem]="'c'+i" domId="chargepoint_info">
            <a ngbNavLink i18n="@@ChargePointInfo"> {{i + 1}}</a>

            <ng-template ngbNavContent>
              <div class="cpGroup mt-3">
                <div class="lableSticker">
                  <label for="qrCodeSticker_{{i}}" i18n="@@QrCodeStickerLabel"
                    class="text-nowrap col-form-label me-2">QR-Code-Sticker</label>
                </div>
                <div class="inputSticker">
                  <input type="text" placeholder="https://mycubos.com/pc?evseid=..." id="qrCodeSticker_{{i}}"
                    formControlName="qrCodeStickerUrl" class="form-control rounded-start rounded-0"
                    [readonly]="this.isUser || this.isCustomer" />

                  <div class="error" *ngIf="formService.formCreated && point.get('qrCodeStickerUrl')?.touched">
                    <em *ngIf="point.get('qrCodeStickerUrl')?.hasError('invalidQrCodeSticker')"
                      i18n="@@InvalidQrCodeStickerError">Ungültiger QR-Code-Sticker</em>
                    <em *ngIf="point.get('qrCodeStickerUrl')?.hasError('duplicateQrCodeSticker')"
                      i18n="@@DuplicateQrCodeStickerError">Doppelte Evse-Id</em>
                  </div>
                </div>
                <div class="btnSticker">
                  <div class="btn-group">
                    <button class="btn btn-outline-tertiary rounded-0" type="button" [id]="'scan_qr_' + i"
                      ngbTooltip="QR-Code-Sticker einscannen" i18n-ngbTooltip="@@QrCodeStickerScanTooltip"
                      (click)="setSelectedChargingPointIndex(i); setScanTarget('qrCodeStickerUrl'); action?.isStart ? action?.stop() : startScannerWithBackCamera(action)">
                      <app-svg
                        *ngIf="action?.isStart && !action?.isLoading && selectedChargingPointIndex === i && scanTarget === 'qrCodeStickerUrl'"
                        source="icons/feather/camera-off" height="18"></app-svg>
                      <div
                        *ngIf="action?.isLoading && selectedChargingPointIndex === i && scanTarget === 'qrCodeStickerUrl'"
                        class="spinner-border border-2" role="status" style="height: 18px; width: 18px;">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <app-svg
                        *ngIf="!action?.isStart && !action?.isLoading || selectedChargingPointIndex !== i || scanTarget !== 'qrCodeStickerUrl'"
                        source="icons/feather/camera" height="18"></app-svg>
                    </button>
                    <button class="btn btn-outline-secondary" type="button" [id]="'copy_qr_' + i"
                      [cdkCopyToClipboard]="point.value.qrCodeStickerUrl" [cdkCopyToClipboardAttempts]="1"
                      (mouseup)="copysuccess()" ngbTooltip="Wert in die Zwischenablage kopieren"
                      i18n-ngbTooltip="@@CopyTooltip">
                      <app-svg source="icons/feather/copy" height="18"></app-svg>
                    </button>
                  </div>
                </div>
                <div class="lableEvseId">
                  <label for="evseId_{{i}}" i18n="@@EvseIdLabel" class="text-nowrap col-form-label me-2">Evse-Id</label>
                </div>
                <div class="inputEvseId">
                  <input type="text" placeholder="DE*CUB*E..." id="evseId_{{i}}" formControlName="evseId"
                    class="form-control rounded-start rounded-0" [readonly]="this.isUser || this.isCustomer" />

                  <div class="error" *ngIf="formService.formCreated && point.get('evseId')?.touched">
                    <em *ngIf="point.get('evseId')?.hasError('invalidEvseId')" i18n="@@StreetRequiredError">
                      Ungültige Evse-Id
                    </em>
                    <em *ngIf="point.get('evseId')?.hasError('duplicateEvseId')" i18n="@@DuplicateEvseIdError">
                      Doppelte Evse-Id
                    </em>
                  </div>


                </div>
                <div class="btnEvseId">
                  <div class="btn-group">
                    <button class="btn btn-outline-tertiary rounded-0" type="button" [id]="'scan_' + i"
                      ngbTooltip="QR-Code mit EVSE-ID einscannen" i18n-ngbTooltip="@@EvseIdScanTooltip"
                      (click)="setSelectedChargingPointIndex(i); setScanTarget('evseId'); action?.isStart ? action?.stop() : startScannerWithBackCamera(action)">
                      <app-svg
                        *ngIf="action?.isStart && !action?.isLoading && selectedChargingPointIndex === i && scanTarget === 'evseId'"
                        source="icons/feather/camera-off" height="18"></app-svg>
                      <div *ngIf="action?.isLoading && selectedChargingPointIndex === i && scanTarget === 'evseId'"
                        class="spinner-border border-2" role="status" style="height: 18px; width: 18px;">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <app-svg
                        *ngIf="!action?.isStart && !action?.isLoading || selectedChargingPointIndex !== i || scanTarget !== 'evseId'"
                        source="icons/feather/camera" height="18"></app-svg>
                    </button>
                    <button class="btn btn-outline-secondary" type="button" [id]="'copy_' + i"
                      [cdkCopyToClipboard]="point.value.evseId" [cdkCopyToClipboardAttempts]="1"
                      (mouseup)="copysuccess()" ngbTooltip="Wert in die Zwischenablage kopieren"
                      i18n-ngbTooltip="@@CopyTooltip">
                      <app-svg source="icons/feather/copy" height="18"></app-svg>
                    </button>
                  </div>

                </div>

                <div class="lablePubKey">
                  <label for="publicKey_{{i}}" i18n="@@PublicKeyLabel" class="col-form-label">Public Key</label>
                </div>
                <div class="inputPubKey">
                  <input type="text" [id]="'public_key_' + i" formControlName="publicKey" class="form-control"
                    [readonly]="this.isUser || this.isCustomer" placeholder="Enter Public Key"
                    i18n-placeholder="@@PublicKeyPlaceholder" />
                </div>
              </div>


            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="cnav"></div>
      </ng-template>

    </li>

    <li [ngbNavItem]="2" domId="advanced_info">
      <a ngbNavLink i18n="@@AdvancedInfo">Erweitert</a>

      <ng-template ngbNavContent>
        <div class="d-grid">
          <label class="details-chargeboxid" i18n="@@ChargeBoxIDLabel">Charge&nbsp;Box&nbsp;ID*</label>
          <div class="d-flex input-group">
            <input type="text" id="chargeboxid" [readonly]="true" class="form-control" value="{{ entity.id }}" />
            <button class="btn btn-outline-secondary" type="button" id="copy" [cdkCopyToClipboard]="entity.id"
              [cdkCopyToClipboardAttempts]="1" (mouseup)="copysuccess()"
              ngbTooltip="Wert in die Zwischenablage kopieren" i18n-ngbTooltip="@@CopyTooltip">
              <app-svg source="icons/feather/copy" height="18"></app-svg>
            </button>
          </div>

          <label class="details-password" *ngIf="config?.isPasswordVisible" i18n="@@PasswordLabel">Passwort</label>
          <div *ngIf="config?.isPasswordVisible" class="d-flex input-group">
            <input type="text" id="pw" [readonly]="true" class="form-control"
              value="{{ entity.key ? entity.key : '547b9a1bcff4c880f46b4ef82d3f3044dec656fa' }}" />
            <button class="btn btn-outline-secondary" type="button"
              [cdkCopyToClipboard]="entity.key ? entity.key : '547b9a1bcff4c880f46b4ef82d3f3044dec656fa'"
              (mouseup)="copysuccess()" ngbTooltip="Wert in die Zwischenablage kopieren"
              i18n-ngbTooltip="@@CopyTooltip">
              <app-svg source="icons/feather/copy" height="18"></app-svg>
            </button>
          </div>
          <label class="details-local-ip" *ngIf="!isUser" i18n="@@LocalIPLabel">Lokale IP</label>
          <div class="d-flex input-group" *ngIf="!isUser">
            <input type="text" id="localIP" class="form-control"
              value="{{ updateDetailsResponse ? updateDetailsResponse.localIP : entity.localIP }}" disabled />
            <a *ngIf="entity.localIP" class="btn btn-yellow" (click)="openLocalIPLink();"
              ngbTooltip="Backend der Ladestation im neuen Fenster öffnen"
              i18n-ngbTooltip="@@OpenChargingStationBackendTooltip" [target]="_blank">
              <app-svg source="icons/feather/external-link" height="18"></app-svg>
            </a>
          </div>


          <!-- <ng-container *ngIf="this.entity.model?.profile.isErk">
      <label class="details-publick-ey" *ngIf="!this.isUser" i18n="@@PublicKeyLabel">Public Key</label>

      <div *ngIf="!this.isUser" class="d-flex input-group">
        <div style="display: grid; grid-template-columns: 1fr; width:100%">
          <div class="d-flex input-group mb-2">
            <input type="text" id="publicKey" class="form-control "
              value="{{ entity.chargingPoints[0]?.publicKey }}" readonly />
            <button class="btn btn-outline-secondary" type="button" id="copy"
              [cdkCopyToClipboard]="this.entity.chargingPoints[0]?.publicKey" [cdkCopyToClipboardAttempts]="1"
              (mouseup)="copysuccess()" ngbTooltip="Wert in die Zwischenablage kopieren"
              i18n-ngbTooltip="@@CopyTooltip">
              <app-svg source="icons/feather/copy" height="18"></app-svg>
            </button>
          </div>
          <div *ngIf="entity.chargingPoints[1]?.publicKey" class="d-flex input-group">
            <input type="text" id="publicKey" class="form-control"
              value="{{ entity.chargingPoints[1]?.publicKey }}" readonly />
            <button class="btn btn-outline-secondary" type="button" id="copy"
              [cdkCopyToClipboard]="this.entity.chargingPoints[1]?.publicKey" [cdkCopyToClipboardAttempts]="1"
              (mouseup)="copysuccess()" ngbTooltip="Wert in die Zwischenablage kopieren"
              i18n-ngbTooltip="@@CopyTooltip">
              <app-svg source="icons/feather/copy" height="18"></app-svg>
            </button>
          </div>
        </div>
      </div>
    </ng-container> -->



          <label i18n="@@CsIdLabel" *ngIf="isOperator">CsId</label>
          <div>
            <input type="text" id="csId" formControlName="csId" class="form-control" *ngIf="isOperator" />
          </div>
        </div>
        <div class="input-group mb-3 ps-2">
          <span class="input-group-text" id="basic-addon3">OCPP-Socket URL</span>
          <input type="text" class="form-control" readonly value="{{this.ocppUrl}}" aria-describedby="basic-addon3">
          <button class="btn btn-outline-secondary" type="button" [cdkCopyToClipboard]="ocppUrl"
            (mouseup)="copysuccess()" ngbTooltip="Wert in die Zwischenablage kopieren" i18n-ngbTooltip="@@CopyTooltip">
            <app-svg source="icons/feather/copy" height="18"></app-svg>
          </button>
        </div>
      </ng-template>
    </li>

    <li [ngbNavItem]="3" domId="manufacturer_info">
      <a ngbNavLink i18n="@@ManufacturerInfo">Herstellerangaben</a>

      <ng-template ngbNavContent>
        <div class="d-grid">
          <label for="manufacturer" i18n="@@ManufacturerLabel">Hersteller</label>
          <input type="text" class="form-control" id="manufacturer" [readonly]="!this.isOperator || isSupporter"
            value="{{ entity.manufacturer?.name }}">

          <label for="model" i18n="@@ModelLabel">Modell</label>
          <input type="text" class="form-control" id="model" [readonly]="!this.isOperator || isSupporter"
            value="{{ entity.model?.name }}">

          <label i18n="@@SeiralNumberLabel">Seriennummer</label>
          <input type="text" id="serial_number" value="{{ entity.serialNumber }}" class="form-control" readonly />

          <label for="installationDate" i18n="@@InstallationDateLabel">Installation</label>
          <input type="date" id="installationDate" formControlName="installationDate" class="form-control" />

          <label i18n="@@ConnectorSystemLabel">Steckertyp</label>
          <!--<ng-element *ngIf="entity?.connectorSystemsId == 1" class="d-inline" ngbToolTip="Typ2 Stecker"><img src="assets/images/typ2.png" /></ng-element>
  <ng-element *ngIf="entity?.connectorSystemsId == 2" class="d-inline" ngbToolTip="CCS Stecker"><img src="assets/images/ccs_eu.png" /></ng-element>-->
          <select class="form-select d-inline-flex" id="connectorSystem" formControlName="connectorSystem"
            aria-label="CustomersSelect">
            <option *ngFor="let connector of connectorSystems" value="{{ connector.id }}">{{ connector.name}}</option>
          </select>

          <label i18n="@@ChargingPowerLabel">Ladeleistung</label>
          <select class="form-select d-inline-flex" id="chargingPowerId" formControlName="chargingPowerId"
            aria-label="ChargingPowerSelect">
            <option *ngFor="let power of this.chargingPower" value="{{ power.id }}">{{ power.kilowatt}} kW
              ({{power.ampere}}A)</option>
          </select>
          <label style="display:none;" i18n="@@CableLengthLabel">Kabellänge</label>
          <input type="number" step="0.1" id="cableLength" formControlName="cableLength" class="form-control"
            style="display:none;" [readonly]="!this.isOperator  || isSupporter" />
        </div>
      </ng-template>
    </li>
  </ul>

  <div class="tab-content" id="nav-tabContent">
    <div [ngbNavOutlet]="snav" class="mt-2"></div>
  </div>
</form>

<ng-template #remoteStartInfo class="form-text">
  <span i18n="@@RemoteStartChargingInfo">Startet den Ladevorgang, wenn oder sobald verbunden.</span>
  <span *ngIf="this.customer
    && entity?.chargingPoints[0]?.statusId == 2
    || entity?.chargingPoints[0]?.statusId == 5
    || entity?.chargingPoints[0]?.statusId == 6
    || entity?.chargingPoints[1]?.statusId == 2
    || entity?.chargingPoints[1]?.statusId == 5
    || entity?.chargingPoints[1]?.statusId == 6" class="form-text" i18n="@@RemoteStartChargingPricingInfo">
    Ermöglicht das Laden eines aktuell verbundenen Fahrzeugs.<br /><strong>Hinweis:</strong> Die kWh
    können nicht in Rechnung gestellt werden.
  </span>
</ng-template>

<ng-template #remoteStopInfo class="form-text">
  <span i18n="@@RemoteStopChargingInfo">Beendet den aktuellen Ladevorgang.</span>
</ng-template>

<ng-template #remoteDisabledInfo class="form-text">
  <span *ngIf="entity?.chargingPoints[0]?.statusId == 1" i18n="@@RemoteDisabledNotRegistered">
    Die Ladestation ist nicht registriert.
  </span>
  <span *ngIf="entity?.chargingPoints[0]?.statusId == 4" i18n="@@RemoteDisabledNotReady">
    Der Ladepunkt ist nicht bereit.
  </span>
  <span *ngIf="entity?.chargingPoints[0]?.statusId == 5" i18n="@@RemoteDisabledTransactionEndByChargingStation">
    Der Ladepunkt beendet den aktuellen Ladevorgang.
  </span>
  <span *ngIf="entity?.chargingPoints[0]?.statusId == 7" i18n="@@RemoteDisabledChargingStationReserved">
    Der Ladepunkt ist reserviert.
  </span>
  <span *ngIf="entity?.chargingPoints[0]?.statusId == 8" i18n="@@RemoteDisabledTransactionEndByVehicle">
    Der Ladevorgang wurde vom Fahrzeug angehalten.
  </span>
  <span *ngIf="entity?.chargingPoints[0]?.statusId == 9" i18n="@@RemoteDisabledTransactionStopped">
    Der Ladevorgang ist angehalten.
  </span>
  <span *ngIf="entity?.chargingPoints[0]?.statusId == 10" i18n="@@RemoteDisabledNotAvailable">
    Der Ladepunkt ist nicht verfügbar.
  </span>
  <span *ngIf="entity?.chargingPoints[0]?.statusId == 11" i18n="@@RemoteDisabledNoConnection">
    Die Ladestation hat keine Verbindung.
  </span>
</ng-template>
